import React, { FC, useMemo } from 'react';

import { DataTable } from 'components/modules/DataTable';

import { buildPendingCountsColumns } from './pendingCountsColumns';

export const PickupsTab: FC = () => {
  const columns = useMemo(() => buildPendingCountsColumns(), []);

  return <DataTable minW="840px" mt={6} data={[]} columns={columns} />;
};
